import React, { useRef, useEffect } from 'react';

function DeleteRecordingsModal({
  show,
  bulk_delete_all,
  selectedCount,
  delete_reason,
  delete_error,
  delete_loading,
  onChangeDeleteReason,
  onCancel,
  onConfirm
}) {
  // outside click ref
  const contentRef = useRef(null);

  useEffect(() => {
    if (!show) return;
    const handler = (e) => {
      if (!contentRef.current) return;
      if (!contentRef.current.contains(e.target)) {
        onCancel(); // close on outside click
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [show, onCancel]);

  if (!show) return null;
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.35)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 999
      }}
    >
      <div
        ref={contentRef}
        style={{
          background: '#fff',
          padding: '20px',
          width: '380px',
          borderRadius: '8px',
          boxShadow: '0 2px 12px rgba(0,0,0,0.2)',
          display: 'flex',
          flexDirection: 'column',
          gap: '12px'
        }}
      >
        <div style={{ fontSize: '16px', fontWeight: '600', color: '#D9534F' }}>
          {bulk_delete_all
            ? 'Are you sure you want to delete all the recordings ?'
            : `Are you sure you want to delete the recording (${selectedCount} selected) ?`}
        </div>
        <div style={{ fontSize: '13px', lineHeight: '18px' }}>
          {bulk_delete_all
            ? 'You are deleting ALL recordings for this student. Provide reason: care team request - PROD-<TICKET-NO>. This cannot be undone.'
            : 'Provide reason in format: care team request - PROD-<TICKET-NO>. Action is irreversible.'}
        </div>
        <textarea
          rows={4}
          placeholder="care team request - PROD-1234"
          value={delete_reason}
          onChange={onChangeDeleteReason}
          style={{
            width: '100%',
            border: '1px solid #ccc',
            borderRadius: '4px',
            padding: '8px',
            resize: 'vertical',
            fontSize: '13px'
          }}
        />
        {delete_error ? <div style={{ color: 'red', fontSize: '12px' }}>{delete_error}</div> : null}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button
            onClick={onCancel}
            style={{
              border: 'none',
              padding: '8px 14px',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '13px',
              background: '#CC5500',
              color: '#fff'
            }}
            disabled={delete_loading}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={
              delete_loading ||
              delete_reason.trim().length === 0 ||
              (!bulk_delete_all && selectedCount === 0)
            }
            style={{
              background:
                delete_loading ||
                delete_reason.trim().length === 0 ||
                (!bulk_delete_all && selectedCount === 0)
                  ? '#999'
                  : '#D9534F',
              color: '#fff',
              border: 'none',
              padding: '8px 14px',
              borderRadius: '4px',
              cursor:
                delete_loading ||
                delete_reason.trim().length === 0 ||
                (!bulk_delete_all && selectedCount === 0)
                  ? 'not-allowed'
                  : 'pointer',
              fontSize: '13px'
            }}
          >
            {delete_loading
              ? 'Deleting...'
              : bulk_delete_all
                ? 'Confirm Delete ALL'
                : 'Confirm Delete'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteRecordingsModal;
